import React from "react";
import { Truck, User2, Wallet, RotateCcw, CreditCard, X } from "lucide-react";

const TransactionModal = ({
  isOpen,
  onClose,
  handleClick,
  setTab,
  mode = "inline",
}) => {
  if (!isOpen) return null;

  const transactionTypes = [
    // {
    //   title: "Material Purchase",
    //   key: "material",
    //   icon: <Truck className="w-5 h-5" />,
    // },
    {
      title: "Worker's Payment",
      key: "worker",
      icon: <User2 className="w-5 h-5" />,
    },
    {
      title: "General Payments",
      key: "other",
      icon: <Wallet className="w-5 h-5" />,
    },
    {
      title: "Add Refund",
      key: "refund",
      icon: <RotateCcw className="w-5 h-5" />,
    },
    {
      title: "Received",
      key: "receive",
      icon: <CreditCard className="w-5 h-5" />,
    },
  ];

  const handleTransactionClick = (transactionKey) => {
    onClose();
    handleClick(transactionKey);
  };

  const panel = (
    <div className="bg-white rounded-2xl border border-gray-200 w-[360px] sm:w-[420px] shadow-xl relative">
      <div className="px-3 py-3 flex mb-4 flex-row items-center justify-between border-b border-gray-200">
        <h2 className="text-lg font-semibold">Add New Transaction</h2>
        <button
          onClick={onClose}
          className=" text-gray-500 hover:text-gray-700 p-1"
        >
          <X className="w-6 h-6" />
        </button>
      </div>
      <div className="flex flex-col gap-3 p-3">
        {transactionTypes.map((type) => (
          <button
            key={type.title}
            onClick={() => handleTransactionClick(type.key)}
            className="flex items-center gap-3 p-4 rounded-lg bg-purple-50 hover:bg-purple-100 transition-colors duration-200 w-full text-left min-h-[56px]"
          >
            <span className="text-purple-600 [&>svg]:w-5 [&>svg]:h-5">
              {type.icon}
            </span>
            <span className="text-purple-900 text-base">{type.title}</span>
          </button>
        ))}
      </div>
    </div>
  );

  if (mode === "inline") {
    return panel;
  }

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 bg-black/30 backdrop-blur-sm">
      {panel}
    </div>
  );
};

export default TransactionModal;
